import { useSelector } from "../store";

export const useWasDunningDialogDismissedSelector = () =>
  useSelector((state) => state.core.wasDunningDialogDismissed);
